import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { kebabCase } from 'lodash';
const ConformanceTooltip = _ref => {
  let _ref$errorText = _ref.errorText,
    errorText = _ref$errorText === void 0 ? null : _ref$errorText,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? null : _ref$target;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipIsOpen = _useState2[0],
    setTooltipIsOpen = _useState2[1];
  const display = errorText && errorText.length ? /*#__PURE__*/React.createElement(Tooltip, {
    trigger: "hover",
    placement: placement,
    isOpen: tooltipIsOpen,
    "data-testid": "t-ct-".concat(kebabCase(errorText)),
    target: target,
    toggle: () => setTooltipIsOpen(!tooltipIsOpen),
    autohide: false
  }, errorText) : null;
  return display;
};
ConformanceTooltip.propTypes = {
  errorText: PropTypes.string,
  target: PropTypes.string,
  placement: PropTypes.string
};
export default ConformanceTooltip;